export default {
    radioButtonContainer: {
        display: "flex",
        columnGap: "40px",
        alignItems: "center"
    },

    label: {
        fontSize: "16px",
        color: "#676767",
        marginBottom: "16px"
    },
    
    formRow: {
        display: "flex",
        columnGap: "40px"
    },

    fieldContainer: {
        width: "60%"
    },
    recipientFieldsContainer: {
        display: 'flex',
        flex: '1 1 0%',
         width: '66%',
    },
    recipientBatch1Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '95%',
    },
    recipientBatch2Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
        marginLeft: '3%',
    },
    stateContainer: {
        wdisplay: 'flex', 
        flexDirection: 'column', 
        width: '95%',
        marginLeft: '3%'
    },
}